(function($){

  // Маска для телефонов
  $('input[type=tel]').mask('8 (000) 000-00-00');


  // Счетчик количества
  $(document).on('click', '.quantity-counter button', function(){
    var parent = $(this).parent('.quantity-counter').get(0),
        quantity = parent.querySelector('input'),
        step = +quantity.getAttribute('step'),
        min = +quantity.getAttribute('min'),
        max = parseInt(quantity.getAttribute('max')),
        quantityValue = parseInt(quantity.value),
        quantityNumberValue = isNaN(quantityValue) ? min : quantityValue;


    if ( $(this).hasClass('quantity-counter-minus') ) {

      if ( (quantityNumberValue - step) >= min ) quantity.value = quantityNumberValue - step;

    } else if ( $(this).hasClass('quantity-counter-plus') ) {

      if ( isNaN(max) || (quantityNumberValue + step) <= max ) quantity.value = quantityNumberValue + step;

    }

    $(quantity).change();
  });


  // Отправка модальных форм
  $('.sintera-modal-form').submit(function(e){
    e.preventDefault();

    var form = $(this),
        button = form.find('[type=submit]'),
        data = new FormData(this);

    button.addClass('loading');

    data.append('action', form.data('action'));

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: data,
      processData: false,
      contentType: false,
      success: function(response) {
        button.removeClass('loading');
        var response = JSON.parse(response);

        // Если это было оформление заказа - переход на Thank You Page
        if (form.data('action') == 'sintera_checkout') {
          window.location.href = response.order_received_url;

        // Если это форма заказа звонка
        } else if (form.data('action') == 'sintera_feedback') {
          form.hide();
          var formTitle = form.parents('.sintera-modal').find('.sintera-modal-title');
          formTitle.text('Заявка отправлена!');
          formTitle.after('<p>Наши менеджеры свяжутся с Вами в ближайшее время.</p>');
        }
      }
    });
  });


  // Клик по переключателю типа каталога
  $('.catalog-switches-item').click(function(){
    if ( this.classList.contains('active') ) return;

    $('.catalog-switches-item.active').removeClass('active');
    this.classList.add('active');

    var type = this.dataset.container;

    if (type == 'brands') {
      $('.sintera-catalog').hide();
      $('.brands-block').show();
    } else if (type == 'categories') {
      $('.brands-block').hide();
      $('.sintera-catalog').show();
    }
  });


  // Открытие мобильной фильтрации
  $('.product-filter-toggler').click(function(){
    $('.filters-sidebar').addClass('active');
    $('body').addClass('modal-open');
  });


  // Закрытие мобильной фильтрации
  $('.filters-sidebar-close').click(function(){
    $('.filters-sidebar').removeClass('active');
    $('body').removeClass('modal-open');
  });


  // Закрытие фильтрации при нажатии на кнопку Применить
  $('.filters-sidebar').on('click', '.sintera-filter-button button', function(){
    $('.filters-sidebar').removeClass('active');
    $('body').removeClass('modal-open');
  });


  // Закрытие фильтрации при нажатии на кнопку Очистить фильтр
  $('.filters-sidebar').on('click', '.sintera-filter-reset button', function(){
    $('.filters-sidebar').removeClass('active');
    $('body').removeClass('modal-open');
  });

})(jQuery);